import styled from "styled-components";

export const Container = styled.div`
  h2 {
    text-transform: capitalize;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }
  .divButton {
    align-self: flex-end;
  }
`;
